jQuery(document).ready(function (jQuery) {
  // Build the 1..100 quantity <option> list once (reused for every cart line)
  var qtyOptions = "";
  for (var q = 1; q <= 100; q++) {
    qtyOptions += '<option value="' + q + '">' + q + "</option>";
  }

  jQuery("#CartMenu").on("click", function () {
    jQuery(".cart-side-menu")
      .removeClass("cart-menu-isClosed")
      .addClass("cart-menu-isOpen");
    jQuery("body").addClass("side-menu-open");
  });
  jQuery(".cart-side-menu-close").on("click", function () {
    jQuery(".cart-side-menu")
      .removeClass("cart-menu-isOpen")
      .addClass("cart-menu-isClosed");
    jQuery("body").removeClass("side-menu-open");
  });

  jQuery(".add-to-cart").on("click", function (e) {
    cart_sidebar_open();
    var form = jQuery(this).closest("form");
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: form.serialize(),
      dataType: "json",
      success: function (cart) {
        cart_sidebar_update();
      },
      error: function (xhr, text) {
        jQuery(".cart-sidebar-error-message").show();
        jQuery(".cart-sidebar-error-message").text(
          jQuery.parseJSON(xhr.responseText).description
        );
        cart_sidebar_update();
        jQuery(".cart-sidebar .cart-sidebar-loading").hide();
      },
    });
    e.preventDefault();
  });

  function cart_sidebar_open() {
    jQuery(".cart-sidebar-error-message").hide().text("");
    jQuery(".cart-side-menu")
      .removeClass("cart-menu-isClosed")
      .addClass("cart-menu-isOpen _loading");
    jQuery("body").addClass("side-menu-open");
  }

  window.RMO_COMPARE = window.RMO_COMPARE || {};
  function rmoEnsureCompare(cart) {
    var handles = [];
    cart.items.forEach(function (it) {
      if (
        window.RMO_COMPARE[it.variant_id] === undefined &&
        it.handle &&
        handles.indexOf(it.handle) === -1
      ) {
        handles.push(it.handle);
      }
    });
    if (!handles.length) return Promise.resolve(false);
    return Promise.all(
      handles.map(function (h) {
        return fetch("/products/" + h + ".js")
          .then(function (r) { return r.json(); })
          .then(function (p) {
            (p.variants || []).forEach(function (v) {
              window.RMO_COMPARE[v.id] =
                v.compare_at_price && v.compare_at_price > v.price
                  ? v.compare_at_price
                  : null;
            });
          })
          .catch(function () {});
      })
    ).then(function () { return true; });
  }

  function cart_sidebar_update() {
    jQuery.getJSON("/cart.js", function (cart) {
      cart_sidebar_update_mini_cart(cart);
      cart_sidebar_update_free_shipping(cart);
      cart_sidebar_update_product(cart);
      cart_sidebar_update_totals(cart);

      jQuery(".cart-sidebar").removeClass("_loading");
      jQuery(".cart-sidebar").removeClass("is_empty");
      jQuery("#cart-items").removeClass("_loading");
      jQuery("#cart-items").removeClass("is_empty");
      if (cart.item_count == 0) {
        jQuery(".cart-sidebar").addClass("is_empty");
        jQuery("#cart-items").addClass("is_empty");
      }

      rmoEnsureCompare(cart).then(function (fetched) {
        if (!fetched) return;
        var hasSale = cart.items.some(function (it) {
          var c = window.RMO_COMPARE[it.variant_id];
          return c && c > it.original_price;
        });
        if (hasSale) cart_sidebar_update_product(cart);
      });
    });
  }

  function cart_sidebar_update_mini_cart(cart) {
    jQuery(".mini-cart-count").text(cart.item_count);
  }
  function cart_sidebar_update_free_shipping(cart) {
    var oilty = false;
    if (cart.item_count > 0) {
      for (var i = 0; i < cart.items.length; i++) {
        if (oilty_id_monthly) {
          if (cart.items[i].id == oilty_id_monthly) {
            oilty = true;
            oilty_type = "monthly";
          }
        }
        if (oilty_id_annually) {
          if (cart.items[i].id == oilty_id_annually) {
            oilty = true;
            oilty_type = "annually";
          }
        }
      }
    }

    if (is_oilty == true) {
      oilty = true;
    }

    if (oilty == true) {
      var free_shipping_price = 15;
    } else {
      var free_shipping_price = 49.95;
    }

    var free_shipping_away = 0;
    var cart_total_price = parseInt(cart.total_price) / 100;
    var free_shipping_bar = Math.round(
      (cart_total_price * 100) / free_shipping_price
    );

    if (cart_total_price >= free_shipping_price) {
      jQuery(".ajax-cart-free-shipping .progress-bar").css("width", "100%");
      if (free_shipping_price == 15) {
        jQuery(".ajax-cart-free-shipping h3").text(
          "QUALIFIED FOR FREE SHIPPING ($15+)"
        );
      } else {
        jQuery(".ajax-cart-free-shipping h3").text(
          "QUALIFIED FOR FREE SHIPPING ($49.95+)"
        );
      }
    } else {
      free_shipping_away = free_shipping_price - cart_total_price;
      if (free_shipping_away < 1) {
        var free_shipping_bar = 99;
      }
      jQuery(".ajax-cart-free-shipping h3").html(
        "Almost There! Add $<span>" +
          free_shipping_away.toFixed(2) +
          "</span> To Unlock Free Shipping"
      );
      jQuery(".ajax-cart-free-shipping .progress-bar").css(
        "width",
        free_shipping_bar + "%"
      );
    }
  }

  function cart_sidebar_update_product(cart) {
    var template =
      '<li class="__cart_sidebar_{ID} __cart_product_{PRODUCT_ID}" data-id="{ID}"><div class="cart-product-wrap"><div class="cp-image"><a href="{URL}"><img src="{IMAGE}" alt="{ALT}" width="75"></a></div><div class="cp-detail"><button type="button" data-id="{ID}" class="shoppingcart-remove-item" aria-label="Remove item"><i class="remove-icon"></i></button><h6>{NAME}</h6>{PLAN}{OPTION}{DISCOUNT}<div class="items-count"><label class="sr-only" for="qty_{ID}">Quantity for {PTITLE}</label><select name="qty" id="qty_{ID}" data-id="{ID}" class="shoppingcart-item-qty qty_{INDEX}" aria-label="Quantity for {PTITLE}">' +
      qtyOptions +
      '</select><span class="p-price"><span>{OLD_PRICE}</span> {PRICE}</span></div>{DONATION_PRICE}</div></div></li>';
    var ProductList = jQuery(".carts-product-list");
    if (cart.item_count > 0) {
      var oilty_status = false;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].image) {
          var __image_url = cart.items[i].image;
          var __image_url_array = __image_url.split(".");
          var __image_url_replace =
            "." + __image_url_array[__image_url_array.length - 1];
          var __image_url_new =
            "_75x120@2x." + __image_url_array[__image_url_array.length - 1];
          var __image_url_final = __image_url.replace(
            __image_url_replace,
            __image_url_new
          );
        } else {
          var __image_url_final =
            "https://cdn.shopify.com/s/files/1/0679/7908/4098/files/favicon.png";
        }

        if (i == 0) {
          ProductList.html("");
        }

        if (cart.items[i].id == oilty_id_monthly) {
          var oilty_status = true;
        }
        if (cart.items[i].id == oilty_id_annually) {
          var oilty_status = true;
        }
        var _price = cart.items[i].original_price;
        var discounted_price = cart.items[i].discounted_price;
        var script_discount_note = false;
        var script_discount_notenote;

        for (var key in cart.items[i].properties) {
          if (cart.items[i].properties.hasOwnProperty(key)) {
            if (key === "Discount Note") {
              script_discount_notenote = cart.items[i].properties[key];
              script_discount_note = true;
            }
          }
        }

        if (script_discount_note === true) {
          var price = Shopify.formatMoney(cart.items[i].original_price);
          var old_price = "";
          var discount_title = script_discount_notenote;
          var discount_html =
            '<p><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></svg> ' +
            discount_title +
            "</p>";
        } else if (_price != discounted_price) {
          var price = Shopify.formatMoney(cart.items[i].discounted_price);
          var old_price = Shopify.formatMoney(cart.items[i].original_price);
          var discount_title = (cart.items[i].discounts && cart.items[i].discounts.length) ? cart.items[i].discounts[0].title : "";
          var discount_html =
            '<p><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></svg> ' +
            discount_title +
            "</p>";
        } else {
          var price = Shopify.formatMoney(cart.items[i].original_price);
          var __cmp = window.RMO_COMPARE[cart.items[i].variant_id];
          var old_price =
            __cmp && __cmp > cart.items[i].original_price
              ? Shopify.formatMoney(__cmp)
              : "";
          var discount_html = "";
        }

        // ---- OPTION / VARIANT (SIZE) RENDERING ----
        var option_html = "";

        // Primary source: options_with_values (e.g. [{name:"Size", value:"5ml"}])
        if (
          cart.items[i].options_with_values &&
          cart.items[i].options_with_values.length
        ) {
          for (var p = 0; p < cart.items[i].options_with_values.length; p++) {
            var opt = cart.items[i].options_with_values[p] || {};
            var optName = opt.name ? String(opt.name).trim() : "";
            var optValue = opt.value ? String(opt.value).trim() : "";
            if (optValue && optValue !== "Default Title") {
              option_html +=
                "<p>" + (optName ? optName + ": " : "") + optValue + "</p>";
            }
          }
        }

        // Fallback: variant_title (e.g. "5ml") when options array is empty
        if (
          !option_html &&
          cart.items[i].variant_title &&
          String(cart.items[i].variant_title).trim() !== "" &&
          String(cart.items[i].variant_title).trim() !== "Default Title"
        ) {
          option_html =
            "<p>" + String(cart.items[i].variant_title).trim() + "</p>";
        }

        // Fallback: line item properties (custom Size stored as property)
        if (!option_html && cart.items[i].properties) {
          for (var propKey in cart.items[i].properties) {
            if (
              cart.items[i].properties.hasOwnProperty(propKey) &&
              propKey !== "Discount Note"
            ) {
              var propVal = cart.items[i].properties[propKey];
              if (propVal !== null && propVal !== "" && propVal !== undefined) {
                option_html += "<p>" + propKey + ": " + propVal + "</p>";
              }
            }
          }
        }
        // ---- END OPTION / VARIANT RENDERING ----

        var plan_html = "";
        if (cart.items[i].selling_plan_allocation) {
          plan_html =
            "<p>" +
            cart.items[i].selling_plan_allocation.selling_plan.name +
            "</p>";
        }

        if (cart.items[i].product_id == "8260603019586") {
          plan_html =
            '<span class="donation-price">' +
            Shopify.formatMoney(cart.items[i].line_price) +
            "</span>";
        }

        var __alt =
          cart.items[i].featured_image && cart.items[i].featured_image.alt
            ? cart.items[i].featured_image.alt
            : cart.items[i].product_title;
        __alt = String(__alt || "")
          .replace(/&/g, "&amp;")
          .replace(/"/g, "&quot;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");

        var __ptitle = String(cart.items[i].product_title || "")
          .replace(/&/g, "&amp;")
          .replace(/"/g, "&quot;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");

        var item = template;
        item = item.replace(/\{ID\}/g, cart.items[i].id);
        item = item.replace(/\{INDEX\}/g, i);
        item = item.replace(/\{URL\}/g, cart.items[i].url);
        item = item.replace(/\{NAME\}/g, cart.items[i].product_title);
        item = item.replace(/\{ALT\}/g, function () {
          return __alt;
        });
        item = item.replace(/\{PTITLE\}/g, function () {
          return __ptitle;
        });
        item = item.replace(/\{VARIANT\}/g, cart.items[i].variant_title || "");
        item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
        item = item.replace(/\{IMAGE\}/g, __image_url_final);
        item = item.replace(/\{OLD_PRICE\}/g, old_price);
        item = item.replace(/\{PRICE\}/g, price);
        item = item.replace(/\{PLAN\}/g, plan_html);
        item = item.replace(/\{OPTION\}/g, option_html);
        item = item.replace(/\{DISCOUNT\}/g, discount_html);
        item = item.replace(/\{DONATION_PRICE\}/g, "");
        item = item.replace(/\{PRODUCT_ID\}/g, cart.items[i].product_id);

        ProductList.append(item);
      }

      if (
        oilty_status == true ||
        is_oilty == true ||
        hide_oilty_signup == true
      ) {
        jQuery(".oilty-plus-cart-sidebar").hide();
      } else {
        jQuery(".oilty-plus-cart-sidebar").show();
        jQuery("#oilty-plus-checkbox").prop("checked", false);
      }

      cart_sidebar_update_dropdown(cart);
    } else {
      ProductList.html("");
      jQuery(".cart-sidebar").addClass("is_empty");
      if (is_oilty == true || hide_oilty_signup == true) {
        jQuery(".oilty-plus-cart-sidebar").hide();
      } else {
        jQuery(".oilty-plus-cart-sidebar").show();
        jQuery("#oilty-plus-checkbox").prop("checked", false);
      }
    }
  }

  function cart_sidebar_update_totals(cart) {
    jQuery(".__subtotal").html(Shopify.formatMoney(cart.total_price));
    jQuery(".__total").html(Shopify.formatMoney(cart.total_price));
    jQuery("#cart-value").val(cart.total_price);
  }

  function cart_sidebar_update_dropdown(cart) {
    if (cart.item_count > 0) {
      for (var i = 0; i < cart.items.length; i++) {
        jQuery(".qty_" + i).val(cart.items[i].quantity);
      }
    }
  }

  function cart_sidebar_update_quantity(product_id, quantity) {
    cart_sidebar_open();
    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=" + quantity + "&id=" + product_id,
      dataType: "json",
      success: function () {
        cart_sidebar_update();
      },
      error: function (xhr, text) {
        jQuery(".cart-sidebar-error-message").show();
        jQuery(".cart-sidebar-error-message").text(
          jQuery.parseJSON(xhr.responseText).description
        );
        cart_sidebar_update();
        jQuery(".cart-sidebar .cart-sidebar-loading").hide();
      },
    });
  }

  jQuery(document).on("change", ".shoppingcart-item-qty", function (e) {
    cart_sidebar_update_quantity(
      jQuery(this).attr("data-id"),
      jQuery(this).val()
    );
  });

  jQuery(document).on("click", ".shoppingcart-remove-item", function (e) {
    cart_sidebar_open();
    var product_id = jQuery(this).attr("data-id");

    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=0&id=" + product_id,
      dataType: "json",
      success: function () {
        cart_sidebar_update();
      },
      error: function (xhr, text) {
        jQuery(".cart-sidebar-error-message").text(
          jQuery.parseJSON(xhr.responseText).description
        );
        jQuery(".cart-sidebar .cart-sidebar-loading").hide();
      },
    });

    e.preventDefault();
  });

  jQuery("#oilty-plus-checkbox").click(function () {
    jQuery(".oilty-plus-add").click();
  });

  jQuery(document).on("click", ".add-subscription", function (e) {
    jQuery(".subscribe-remove").show();
    jQuery(".add-subscription").hide();
    jQuery(".selling-option").show();
    jQuery("#selling_plan").val(jQuery("#selling_option").val());
    subscription_update();
  });

  jQuery(document).on("click", ".subscribe-remove", function (e) {
    jQuery(".subscribe-remove").hide();
    jQuery(".add-subscription").show();
    jQuery(".selling-option").hide();
    jQuery("#selling_plan").val("");
    subscription_update();
  });

  jQuery(document).on("change", "#selling_option", function (e) {
    jQuery("#selling_plan").val(jQuery(this).val());
    subscription_update();
  });

  jQuery(document).on("change", ".subscription__select", function (e) {
    var selected_option = jQuery(this).val().toLowerCase();
    var selling_id = jQuery(".selling_plan_" + selected_option).attr("data-id");
    jQuery("#subscription_selling_plan").val(selling_id);
  });

  function subscription_update() {
    var price = jQuery(".product-subscribe").attr("data-price");
    var compare_price = jQuery(".product-subscribe").attr("data-compare-price");
    var discount = jQuery("#selling_option")
      .find(":selected")
      .attr("data-discount");
    var selling_plan = jQuery("#selling_plan").val();

    if (selling_plan) {
      var subscription_price = price - (price * discount) / 100;
      var html =
        '<span class="actual-price">' +
        Shopify.formatMoney(price) +
        '</span><strong class="subscribe-price">' +
        Shopify.formatMoney(subscription_price) +
        "<span>" +
        discount +
        "% Off</span></strong>";
      jQuery(".product-price").html(html);
      jQuery(".product-price").addClass("sale");
    } else {
      if (compare_price > price) {
        jQuery(".product-price").addClass("sale");
        var html =
          '<span class="actual-price">' +
          Shopify.formatMoney(compare_price) +
          "</span><strong>" +
          Shopify.formatMoney(price) +
          "</strong>";
        jQuery(".product-price").html(html);
      } else {
        var html =
          '<span class="actual-price"></span><strong>' +
          Shopify.formatMoney(price) +
          "</strong>";
        jQuery(".product-price").removeClass("sale");
        jQuery(".product-price").html(html);
      }
    }
  }

  jQuery(document).on("click", ".other-payment", function (e) {
    jQuery(".additional-checkout-buttons").toggleClass("active");
    jQuery(this).toggleClass("active");
    e.preventDefault();
  });

  jQuery(document).on("click", ".checkout-popup", function (e) {
    if (typeof oilty_gift !== "undefined" && oilty_gift == true && typeof oilty_status !== "undefined" && oilty_status == true) {
      var total_price = jQuery("#cart-value").val();
      var popup_type = jQuery("#cart-type").val();

      if (popup_type == "annually") {
        total_price = total_price - 9995;
      }

      if (total_price > 100) {
        window.location.href = "/checkout";
      }

    } else {
      window.location.href = "/checkout";
    }
  });

  jQuery(".oilty-options").change(function () {
    if (this.value == oilty_id_monthly) {
      jQuery("#checkout-selling-id").val(
        jQuery("#checkout-selling-id").data("monthly")
      );
    } else {
      jQuery("#checkout-selling-id").val(
        jQuery("#checkout-selling-id").data("yearly")
      );
    }
  });
});